import React, { useState, useEffect } from 'react';
import './SponsorshipManager.css';
import { useNavigate } from 'react-router-dom';
import backIcon from '../../assets/backspace-icon.png';
import api from '../../api';

function SponsorshipManager() {
  const navigate = useNavigate();
  const [sponsorships, setSponsorships] = useState([]);
  const [filter, setFilter] = useState('pending');

  useEffect(() => {
    const fetchSponsorships = async () => {
      try {
        const res = await api.get('/sponsorships/all');
        setSponsorships(res.data.products);
      } catch (err) {
        console.error('❌ Failed to fetch sponsorships:', err);
      }
    };

    fetchSponsorships();

    const handleVisibility = () => {
      if (document.visibilityState === 'visible') {
        fetchSponsorships(); // 🔄 reload when admin returns to this tab
      }
    };

    document.addEventListener('visibilitychange', handleVisibility);
    return () => document.removeEventListener('visibilitychange', handleVisibility);
  }, []);

  const filtered = sponsorships.filter((s) => {
    if (filter === 'all') return true;

    if (filter === 'active') {
      return (
        s.sponsorshipStatus === 'approved' &&
        s.sponsorshipPaid === true &&
        new Date(s.sponsorshipExpiresAt) > new Date()
      );
    }

    if (filter === 'pending') {
      return (
        s.sponsorshipStatus === 'pending' ||
        (s.sponsorshipStatus === 'approved' && !s.sponsorshipPaid)
      );
    }

    return s.sponsorshipStatus === filter;
  });

  return (
    <div className="sponsorship-manager-container">
      {/* Fixed Topbar */}
      <div className="sponsorship-topbar">
        <img
          src={backIcon}
          alt="Back"
          className="sponsorship-back-icon"
          onClick={() => navigate(-1)}
        />
        <h2 className="sponsorship-header">Product Sponsorships</h2>
      </div>

      {/* Scrollable content: filters + cards */}
      <div className="sponsorship-scroll-area">
        <div className="sponsorship-filters">
          <button
            className={filter === 'pending' ? 'active' : ''}
            onClick={() => setFilter('pending')}
          >
            Pending
          </button>
          <button
            className={filter === 'active' ? 'active' : ''}
            onClick={() => setFilter('active')}
          >
            Active
          </button>
          <button
            className={filter === 'rejected' ? 'active' : ''}
            onClick={() => setFilter('rejected')}
          >
            Rejected
          </button>
        </div>

        {filtered.length === 0 ? (
          <p className="empty-message">No sponsorships in this category.</p>
        ) : (
          filtered.map((s) => (
            <div
              key={s._id}
              className="sponsorship-card"
              onClick={() => navigate(`/admin/sponsorships/${s._id}`)}
            >
             <h4>{s.businessName || 'Unnamed Business'}</h4>

              <p>
                Business Owner: {s.username}
              </p>


<p>
  Status: <strong>{s.sponsorshipStatus}</strong>
</p>

{/** 🔸 Awaiting payment label now on a new line */}
{s.sponsorshipStatus === 'approved' && !s.sponsorshipPaid && (
  <p style={{ color: 'orange', fontStyle: 'italic', marginTop: -8 }}>
    Awaiting payment
  </p>
)}


              <p>Applied: {new Date(s.sponsorshipSubmittedAt).toLocaleDateString()}</p>
            </div>
          ))
        )}
      </div>
    </div>
  );
}

export default SponsorshipManager;
